import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0033',
    ecrans: ['00-2'],
    params: [ '?doccleintref','?histo' ]
});

